import React from 'react';
import { FieldRow } from 'components/Form/subcomponents/FieldRow';
import { ButtonsRow, CleanFilter, ModalContent, SaveButton, StyledModal } from './styled';
import { MultiSelectDropdown, FilterOption } from 'newComponents/Form/Multiselect';
import { FormGroup } from 'components/Form/subcomponents/FormGroup';
import { ReactComponent as XIcon } from 'assets/icons/ui-elements/small/x-mark-sm.svg';

interface EnvironmentsEquipmentModalProps {
  title: string;
  setClose: (open: boolean) => void;
  maintenanceUnitsOptions: FilterOption[];
  areaGroupsOptions: FilterOption[];
  areaSubgroupsOptions: FilterOption[];
  areasOptions: FilterOption[];
  equipmentTypesOptions: FilterOption[];
  equipmentOptions: FilterOption[];
  maintenanceUnitsValues: string[];
  areaGroupsValues: string[];
  areaSubgroupsValues: string[];
  areasValues: string[];
  equipmentTypesValues: string[];
  equipmentValues: string[];
  onMaintenanceUnitsChange: (values: unknown) => void;
  onAreaGroupsChange: (values: unknown) => void;
  onAreaSubgroupsChange: (values: unknown) => void;
  onAreasChange: (values: unknown) => void;
  onEquipmentTypesChange: (values: unknown) => void;
  onEquipmentChange: (values: unknown) => void;
  onFilter: () => void;
  onClearFilters: () => void;
  onLoadMoreAreas?: () => void;
  onSearchArea?: (term: string) => void;
  onLoadMoreEquipamentos?: () => void;
  onSearchEquipamento?: (term: string) => void;
}

export const EnvironmentsEquipmentModal: React.FC<EnvironmentsEquipmentModalProps> = ({
  title,
  setClose,
  maintenanceUnitsOptions,
  areaGroupsOptions,
  areaSubgroupsOptions,
  areasOptions,
  equipmentTypesOptions,
  equipmentOptions,
  maintenanceUnitsValues,
  areaGroupsValues,
  areaSubgroupsValues,
  areasValues,
  equipmentTypesValues,
  equipmentValues,
  onMaintenanceUnitsChange,
  onAreaGroupsChange,
  onAreaSubgroupsChange,
  onAreasChange,
  onEquipmentTypesChange,
  onEquipmentChange,
  onFilter,
  onClearFilters,
  onLoadMoreAreas,
  onSearchArea,
  onLoadMoreEquipamentos,
  onSearchEquipamento,
}) => {
  return (
    <StyledModal title={title} setClose={setClose}>
      <ModalContent>
        <FieldRow marginBottom="20px" />
        <FormGroup label="Unidades de manutenção">
          <MultiSelectDropdown
            options={maintenanceUnitsOptions}
            value={maintenanceUnitsValues}
            onChange={onMaintenanceUnitsChange}
            size="md"
            width="416px"
            placeholder="Selecione"
            clearable={true}
            top="27px"
          />
        </FormGroup>
        <FieldRow marginBottom="20px" />

        <FormGroup label="Grupo de áreas">
          <MultiSelectDropdown
            options={areaGroupsOptions}
            value={areaGroupsValues}
            onChange={onAreaGroupsChange}
            size="md"
            width="416px"
            placeholder="Selecione"
            clearable={true}
            top="27px"
          />
        </FormGroup>
        <FieldRow marginBottom="20px" />

        <FormGroup label="Subgrupo de áreas">
          <MultiSelectDropdown
            options={areaSubgroupsOptions}
            value={areaSubgroupsValues}
            onChange={onAreaSubgroupsChange}
            size="md"
            width="416px"
            placeholder="Selecione"
            clearable={true}
            top="27px"
          />
        </FormGroup>
        <FieldRow marginBottom="20px" />

        <FormGroup label="Áreas">
          <MultiSelectDropdown
            options={areasOptions}
            value={areasValues}
            onChange={onAreasChange}
            size="md"
            width="416px"
            placeholder="Selecione"
            clearable={true}
            top="27px"
            searchable={true}
            searchMode="remote"
            dataMode="infinite"
            onSearch={onSearchArea}
            onScrollEnd={onLoadMoreAreas}
          />
        </FormGroup>
        <FieldRow marginBottom="20px" />

        <FormGroup label="Tipo de equipamentos">
          <MultiSelectDropdown
            options={equipmentTypesOptions}
            value={equipmentTypesValues}
            onChange={onEquipmentTypesChange}
            size="md"
            width="416px"
            placeholder="Selecione"
            clearable={true}
            top="27px"
          />
        </FormGroup>
        <FieldRow marginBottom="20px" />

        <FormGroup label="Equipamentos">
          <MultiSelectDropdown
            options={equipmentOptions}
            value={equipmentValues}
            onChange={onEquipmentChange}
            size="md"
            width="416px"
            placeholder="Selecione"
            clearable={true}
            top="27px"
            searchable={true}
            searchMode="remote"
            dataMode="infinite"
            onSearch={onSearchEquipamento}
            onScrollEnd={onLoadMoreEquipamentos}
          />
        </FormGroup>
        <FieldRow marginBottom="20px" />

        <ButtonsRow>
          <SaveButton onClick={onFilter}>Filtrar</SaveButton>
          <CleanFilter onClick={onClearFilters} title="Limpar filtros de Ambientes e Equipamentos">
            <XIcon />
            Limpar filtros
          </CleanFilter>
        </ButtonsRow>
      </ModalContent>
    </StyledModal>
  );
};
